export default "__VITE_ASSET__CTUnV3_b__"